<template>
    <div class="row justify-content-center px-3">
        <div class="col-12 mt-2 row justify-content-center">
            <p>
                {{ t('confirm_phrase-instruction') }}
            </p>
            <p class="col-12 text-uppercase">
                <span v-for="(char, index) in placeholderText" :key="index" :style="{ color: getColor(index) }">
                    <strong v-if="char != ' '">{{ char }}</strong>
                    <strong v-else class="mx-1"></strong>
                </span>
            </p>
            <KvInput v-model="userInput" class="confirm-phrase-input mb-2" variant="outlined" :placeholder="t('confirm_phrase-placeholder')" />
        </div>
    </div>
</template>

<script>
import KvInput from "./kv-input.vue";

export default {
    name: "confirm-phrase",
    components: {
        KvInput,
    },
    data() {
        return {
            userInput: "",
        };
    },
    watch: {
        userInput(newInput) {
            const isCorrect = newInput.toLowerCase() === this.placeholderText.toLowerCase();
            this.$emit("input", isCorrect);
        },
        placeholderText(){
            this.userInput = "";
        }
    },
    props: {
        placeholderText: {
            type: String,
            required: true
        },
        colorText: {
            type: String,
            default: "red"
        }
    },
    methods: {
        t: function (term, replaces) {
            return this.$root.t(term, replaces);
        },
        getColor(index) {
            if (this.userInput[index]?.toLowerCase() === this.placeholderText[index]?.toLowerCase()) {
                return this.colorText;
            }
            return;
        },
    }
};
</script>

<style lang="scss" scoped>
.confirm-phrase-input {
    max-width: 360px;
    width: 100%;
}
</style>
